import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';

// Tabs
import StaffPaperPendencyDayInterruptions from './StaffPaperPendencyDayInterruptions';
import getLocale from '../../../i18n/getLocale';

class StaffPaperPendencyDay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      aircraft_model_id: null,
      date: null,
      modal: false,
      modal_interruptions: false,
      schedule_initials_select: [],
      aircraft_models_select: [],
      staff_paper_day_aircraft_models: [],
      staff_paper_day_interruptions: [],
      id: this.props.day.id,
      schedule_initial: null,
      schedule_initial_id: this.props.day.schedule_initial_id,
      departure_location: this.props.day.departure_location,
      arrival_location: this.props.day.arrival_location,
      add_interruption_start: this.props.day.start,
      start: this.props.day.start,
      interruption_start: this.props.day.interruption_start,
      interruption_finish: this.props.day.interruption_finish,
      second_interruption_start: this.props.day.second_interruption_start,
      second_interruption_finish: this.props.day.second_interruption_finish,
      add_interruption_finish: this.props.day.finish,
      total_time: this.props.day.total_time,
      night_time: this.props.day.night_time,
      flight_time: this.props.day.flight_time,
      updated: 0,
    };
    //bind específico
    this.autoUpdate = this.autoUpdate.bind(this);

    this.locale = getLocale();
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 || newProps.updated == true) && typeof newProps.day.date !== 'undefined' && Array.isArray(newProps.schedule_initials_select) && Array.isArray(newProps.aircraft_models_select)) {
      this.setState({
        id: newProps.day.id,
        staff_paper_day_aircraft_models: newProps.day.staff_paper_pendency_day_aircraft_models,
        staff_paper_day_interruptions: newProps.day.staff_paper_pendency_day_interruptions,
        schedule_initial_id: newProps.day.schedule_initial_id,
        schedule_initial: newProps.day.schedule_initial.name,
        departure_location: newProps.day.departure_location,
        arrival_location: newProps.day.arrival_location,
        start: newProps.day.start_str,
        interruption_start: newProps.day.interruption_start_str,
        interruption_finish: newProps.day.interruption_finish_str,
        second_interruption_start: newProps.day.second_interruption_start_str,
        second_interruption_finish: newProps.day.second_interruption_finish_str,
        finish: newProps.day.finish_str,
        total_time: newProps.day.total_time,
        night_time: newProps.day.night_time,
        flight_time: newProps.day.flight_time,
        interruption_time: newProps.day.interruption_time,
        date: newProps.day.date_str,
        schedule_initials_select: newProps.schedule_initials_select,
        aircraft_models_select: newProps.aircraft_models_select,
        loaded: 1,
      });
    }
    if(newProps.updated == true) {
      this.props.changeUpdate();
      
    }
  }

  autoUpdate() {
      if(window.confirm(this.locale.Papeletas.EditarPapeleta.tabelaPendencias.AtualizarAsInformacoesDestaDataDeAcordoComAPendencia)) {
          
        var url = "/papeleta/pendencia/dia/atualizar/";
        var header = this.props.RequestApi.header('application/json');
        this.props.handleAlert('', '', 'open');
        var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          }
        });
      });
    }
  }


  render() {
    var self = this;
    return (
        <tr>
        <td className="text-center">{self.state.date}</td>
        <td className="text-center">{self.state.departure_location}</td>
        <td className="text-center">{self.state.arrival_location}</td>
        <td className="text-center">{self.state.schedule_initial}</td>
        <td className="text-center">{self.state.start}</td>
        <td className="text-center">{self.state.interruption_start}</td>
        <td className="text-center">{self.state.interruption_finish}</td>
        <td className="text-center">{self.state.second_interruption_start}</td>
        <td className="text-center">{self.state.second_interruption_finish}</td>
        <td className="text-center">{self.state.finish}</td>
        <td className="text-center">{self.state.total_time}</td>
        <td className="text-center">{self.state.night_time}</td>
        <td className="text-center">{self.state.flight_time}</td>
        <td className="text-center">
          <button onClick={() => self.autoUpdate()} className="btn btn-primary btn-sm"><i className="fa fa-check"></i> </button>
        </td>
        <td className="text-center">
            <button type="button" onClick={()=>this.setState({ modal_interruptions: true })} className="btn btn-warning btn-sm"><i className="fa fa-clock-o"></i></button>
            <Modal show={this.state.modal_interruptions} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
                <Modal.Header>
                    <h4 className="pull-left">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tituloInterrupcoes}</h4>
                    <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_interruptions: false })}>
                    <i className="fa fa-fw fa-close"></i></button>
                    <div className="clearfix"></div>
                </Modal.Header>
                <Modal.Body>
                <div className="table-responsive">
                    <table className="table table-bordered table-hover table-striped">
                        <thead>
                            <tr>
                            <th style={{textAlign: 'center'}}>{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tabelaInterrupcoes.Inicio}</th>
                            <th style={{textAlign: 'center'}}>{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tabelaInterrupcoes.Fim}</th>
                            <th style={{textAlign: 'center'}}>{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tabelaInterrupcoes.Total}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(self.state.staff_paper_day_interruptions).map(function(k) {
                            var interruption = self.state.staff_paper_day_interruptions[k];
                                return (
                                    <StaffPaperPendencyDayInterruptions handleAlert={self.props.handleAlert} editInterruptions={self.editInterruptions} deleteInterruptions={self.deleteInterruptions} updated={self.state.updated} interruption={interruption} staff_paper_day_id={self.state.id}/>
                                );
                            })}
                            <tr>
                                <td colSpan={2} style={{ textAlign: 'right', fontWeight: 700  }}>{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tabelaInterrupcoes.Total}</td>
                                <td style={{ textAlign: 'center', fontWeight: 700  }}>{self.state.interruption_time}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_interruptions: false })}>
                    <i className="fa fa-fw fa-close"></i></button>
                </Modal.Footer>
            </Modal>
        </td>
        <td className="text-center">
            <button type="button" onClick={()=>this.setState({ modal: true })} className="btn btn-info btn-sm"><i className="fa fa-fw fa-plane"></i></button>       
            <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
                <Modal.Header>
                    <h4 className="pull-left">{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tituloEquipamentos}</h4>
                    <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
                    <i className="fa fa-fw fa-close"></i></button>
                    <div className="clearfix"></div>
                </Modal.Header>
                <Modal.Body>
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover table-striped">
                            <thead>
                                <tr>
                                <th style={{textAlign: 'center'}}>{this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tabelaEquipamentos.Frota}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(self.state.staff_paper_day_aircraft_models).map(function(k) {
                                var spdam = self.state.staff_paper_day_aircraft_models[k];
                                    return (
                                        <tr>
                                            <td style={{textAlign: 'center'}}>{spdam.aircraft_model.model}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
                    <i className="fa fa-fw fa-close"></i></button>
                </Modal.Footer>
            </Modal>
        </td>
      </tr>            

    );
  }
}

export default StaffPaperPendencyDay;



// WEBPACK FOOTER //
// ./src/Components/StaffPapers/Elements/StaffPaperPendencyDay.js